import { present } from "../../../utils/presenter";
import { ProjectHistory } from "../../adapters/projectHistory";
import { Interactor } from "./types";

function createInteractor(history: ProjectHistory): Interactor {
  return (project) =>
    present(
      history
        .pushHistory(project.uuid)
        .then(() => project)
        .catch(() => project),
    );
}

export type { Interactor };

export { createInteractor };
